import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import swConfig from "./swConfig";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./styles/main_styles.css";
import "./styles/responsive.css";
import "./fontawesome_pro/css/fontawesome-all.css";
import "./styles/ania_chat.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";

import "./js/ania_chat.js";
const rootElement = document.getElementById("root");

const requestNotificationPermission = async () => {
  const permission = await window.Notification.requestPermission();
  // value of permission can be 'granted', 'default', 'denied'
  // granted: user has accepted the request
  // default: user has dismissed the notification permission popup by clicking on x
  // denied: user has denied the request.
  console.log(permission);
  if (permission !== "granted") {
    throw new Error("Permission not granted for Notification");
  }
};
const showLocalNotification = async (title, body, swRegistration) => {
  console.log("ttttttt");
  const register = await navigator.serviceWorker.register(
    `${process.env.PUBLIC_URL}/service-worker.js`,
    {
      scop: "/",
    }
  );
  const options = {
    body,
    // here you can add more properties like icon, image, vibrate, etc.
  };
  register.showNotification(title, options);
};
const root = createRoot(rootElement);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register(swConfig);
requestNotificationPermission();
